import { InputAdornment, SxProps, TextField } from '@mui/material';
import { BaseTheme, mergeSx, IconButton } from 'design-system';
import { useState } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { Field } from 'generated/graphql';

const PasswordTextfield = ({
  field,
  isDisabled,
  sx,
  onChange,
}: {
  field: Field;
  isDisabled: boolean;
  sx?: SxProps<BaseTheme>;
  onChange(value: string, values?: string[]): void;
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      fullWidth
      name="password"
      value={field.value}
      onChange={(event) => onChange(event.target.value || '')}
      label="Password"
      required={field.required}
      disabled={isDisabled}
      type={showPassword ? 'text' : 'password'}
      variant="outlined"
      sx={mergeSx(
        (theme) => ({
          marginTop: theme.spacing(1),
        }),
        sx ?? {},
      )}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                color="primary"
                aria-label="toggle password visibility"
                onClick={() => setShowPassword((current) => !current)}
                track={false}
              >
                {showPassword ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default PasswordTextfield;
